import styled from "styled-components";

import BaseURL from "./../data/images/Hosting-BaseURL";

const pillar1Image = `${BaseURL}/buttons/pillar-size-1.png`;
const pillar2Image = `${BaseURL}/buttons/pillar-size-2.png`;
const pillar3Image = `${BaseURL}/buttons/pillar-size-3.png`;
const pillar1DarkImage = `${BaseURL}/buttons/pillar-size-1-dark.png`;
const pillar2DarkImage = `${BaseURL}/buttons/pillar-size-2-dark.png`;
const pillar3DarkImage = `${BaseURL}/buttons/pillar-size-3-dark.png`;

const UnitPillar = styled.div`
    background: url(${props => (props.isMegadeus || props.isMegadeusPlus || props.isMegadeusPlusPlus || props.isMegadeusOmega) ? pillar3DarkImage : props.isExtraLarge ? pillar2DarkImage : pillar1DarkImage});
    position: absolute;
    align-self: flex-end;
    top: ${props => (props.isMegadeus || props.isMegadeusPlus || props.isMegadeusPlusPlus || props.isMegadeusOmega) ? 150 : props.isExtraLarge ? 150 : props.isExtraSmall ? 50 : 100}px;
    left: -${props => (props.isMegadeus || props.isMegadeusPlus || props.isMegadeusPlusPlus || props.isMegadeusOmega) ? 75 : 15}px;
    z-index: -1;
    width: ${props => (props.isMegadeus || props.isMegadeusPlus || props.isMegadeusPlusPlus || props.isMegadeusOmegas) ? 462 : props.isExtraLarge ? 318 : 230}px;
    height: 347px;

    &.light {
        background: url(${props => (props.isMegadeus || props.isMegadeusPlus || props.isMegadeusPlusPlus || props.isMegadeusOmega) ? pillar3Image : props.isExtraLarge ? pillar2Image : pillar1Image});
    }

    @media only screen and (max-width: ${props => props.theme.tabletCutoffWidth}px) {
        display: none;
    }
`;

UnitPillar.displayName = "UnitPillar";

export default UnitPillar;
